import { render, staticRenderFns } from "./ActivationReminder.vue?vue&type=template&id=5fb9a62a&"
import script from "./ActivationReminder.vue?vue&type=script&lang=js&"
export * from "./ActivationReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports